import { render, staticRenderFns } from "./drawStep.vue?vue&type=template&id=08c00d0a&scoped=true"
import script from "./drawStep.vue?vue&type=script&lang=js"
export * from "./drawStep.vue?vue&type=script&lang=js"
import style0 from "./drawStep.vue?vue&type=style&index=0&id=08c00d0a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c00d0a",
  null
  
)

export default component.exports